// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".28ec38a9df3133d0dc56da4d1b8f32632409569a.chunk.js";
};